import { SelectInput } from "react-admin";
const choices = [
  { id: true, name: "Yes" },
  { id: false, name: "No" },
];

export const NullableBooleanField = (props) => {
  return (
    <SelectInput
      className="NullableBooleanField"
      choices={choices}
      {...props}
    />
  );
};
